// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3LhTL","title":"ClientInsurance_title__1JVyP","itemText":"ClientInsurance_itemText__3tPSk"};